import { render, staticRenderFns } from "./qihangSchoolAgreementDetail.vue?vue&type=template&id=497cd6c7&scoped=true&"
import script from "./qihangSchoolAgreementDetail.vue?vue&type=script&lang=js&"
export * from "./qihangSchoolAgreementDetail.vue?vue&type=script&lang=js&"
import style0 from "./qihangSchoolAgreementDetail.vue?vue&type=style&index=0&id=497cd6c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497cd6c7",
  null
  
)

export default component.exports